const teamManagement = {
  title: "Team Management",
  tabs: {
    employees: "Employees Management",
    roles: "Roles Management",
  },
  rowsPerPageLabel: "Number Of Rows",
  employees: {
    searchPlaceholder: "Search employees",
    addEmployee: "Add Employee",
    table: {
      name: "Employee Name",
      email: "Email",
      mobileNumber: "Mobile Number",
      role: "Role",
      actions: "Actions",
      edit: "Edit",
      remove: "Remove",
    },
    rangeTemplate: "Showing {from}-{to} of {total} employees",
    emptyTitle: "No Employees Yet",
    emptyDescription:
      "Would you like to add new employees? Once you add them, they will appear in this table.",
    searchEmptyTitle: "Sorry, no employees found.",
    deleteModal: {
      title: "Remove Employee",
      question: 'Are you sure you want to remove "{name}"?',
      cancel: "Cancel",
      delete: "Remove",
    },
  },
  roles: {
    searchPlaceholder: "Search roles",
    createRole: "Create New Role",
    table: {
      name: "Role",
      usersCount: "No. of Users",
      status: "Status",
      actions: "Actions",
      edit: "Edit",
      remove: "Remove",
    },
    rangeTemplate: "Showing {from}-{to} of {total} roles",
    emptyTitle: "No Roles Yet",
    emptyDescription:
      "Would you like to create new roles? Once you create them, they will appear in this table.",
    searchEmptyTitle: "Sorry, no roles found.",
    deleteModal: {
      title: "Delete Role",
      question: 'Are you sure you want to delete "{role}"?',
      blockedMessage:
        '"{role}" is assigned to {count} user(s) and can\'t be deleted. Reassign those users to another role first.',
      cancel: "Cancel",
      delete: "Delete",
    },
  },
  createRole: {
    title: "Create New Role",
    subtitle: "Configure name and granular access levels for this role.",
    roleNameLabel: "Role Name",
    roleNamePlaceholder: "Enter role name",
    roleNameRequired: "Role name is required",
    modulesHeader: "Modules",
    moduleCount: "{count} Modules",
    lockedHint: "Automatically granted by another permission you selected.",
    levels: {
      view: "View",
      add: "Add",
      edit: "Edit",
      delete: "Delete",
    },
    groups: {
      coreOperations: "Core Operations",
      hrFinance: "HR & Finance",
      managements: "Managements",
      analyticsReports: "Analytics & Reports",
    },
    modules: {
      applicants: "Loyal Applicants",
      employees: "Employees",
      joiningEvents: "Event Applicants",
      events: "Events",
      payroll: "Payroll",
      timesheet: "Timesheet",
      manageClients: "Manage Clients",
      manageReports: "Manage Reports",
      evaluations: "Evaluations",
      reports: "Reports",
      surveyScore: "Survey Score",
      heatmap: "Heatmap",
      rolesManagement: "Roles Management",
    },
    cancel: "Cancel",
    submit: "Create Role",
  },
  addEmployee: {
    title: "Add New Employee",
    detailsTitle: "Details",
    pictureLabel: "Profile Pic",
    uploadPicture: "Upload Photo",
    changePicture: "Change",
    uploading: "Uploading",
    fields: {
      name: "Name",
      namePlaceholder: "Enter full name",
      email: "Email",
      emailPlaceholder: "Enter email address",
      mobileNumber: "Mobile Number",
      role: "Role",
      rolePlaceholder: "Select role",
    },
    validations: {
      nameRequired: "Name is required",
      emailRequired: "Email is required",
      emailInvalid: "Please enter a valid email address",
      roleRequired: "Role is required",
      phoneRequired: "Mobile number is required",
    },
    cancel: "Cancel",
    submit: "Add",
    createSuccess: "Employee profile created successfully.",
  },
  viewEmployee: {
    title: "Employee profile",
    detailsTitle: "Details",
    idLabel: "ID:",
    editProfile: "Edit Profile",
    deleteEmployee: "Delete Employee",
    emptyValue: "—",
    cancel: "Cancel",
    update: "Update",
    updateSuccess: "Employee profile updated successfully.",
    fields: {
      name: "Name",
      email: "Email",
      mobileNumber: "Mobile Number",
      role: "Role",
    },
  },
  viewRole: {
    titleTemplate: "{name} role details",
    subtitle: "View specific permissions and access levels for this role.",
    roleNameLabel: "Role Name",
    editPermissions: "Edit Permissions",
    updatePermissions: "Update Permissions",
    cancel: "Cancel",
    updateSuccess: "Permissions for {name} updated successfully!",
  },
};

export default teamManagement;
